import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const DataEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"blue.400"} />;
};
